/**
 * Payment Cancel Page
 *
 * Displayed when user cancels Stripe checkout
 */

import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const PaymentCancelPage = () => {
  const { t } = useTranslation('pricing');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-muted to-muted py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-card rounded-2xl shadow-xl p-8 text-center">
          {/* Cancel Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-6">
            <svg className="h-10 w-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          {/* Title */}
          <h2 className="text-3xl font-bold text-foreground mb-4">
            {t('payment.cancel.title', 'Payment Cancelled')}
          </h2>

          {/* Message */}
          <p className="text-lg text-muted-foreground mb-8">
            {t('payment.cancel.message', "No worries! Your payment was not processed. You can try again whenever you're ready.")}
          </p>

          {/* Info Box */}
          <div className="bg-accent rounded-lg p-6 mb-8 text-left">
            <h3 className="font-semibold text-accent-foreground mb-2">
              {t('payment.cancel.infoTitle', 'Need help choosing?')}
            </h3>
            <p className="text-sm text-accent-foreground/80">
              {t('payment.cancel.infoMessage', 'Check out our pricing page to compare plans, or contact us if you have questions.')}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={() => navigate('/pricing')}
              className="w-full bg-primary text-primary-foreground py-3 px-6 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
            >
              {t('payment.cancel.backToPricingButton', 'Back to Pricing')}
            </button>
            <button
              onClick={() => navigate('/')}
              className="w-full bg-muted text-foreground py-3 px-6 rounded-lg font-semibold hover:bg-muted/80 transition-colors"
            >
              {t('payment.cancel.homeButton', 'Go Home')}
            </button>
          </div>

          {/* Contact Link */}
          <p className="mt-6 text-sm text-muted-foreground">
            {t('payment.cancel.questions', 'Questions?')}{' '}
            <a href="mailto:info@forecast-engine.com" className="text-primary hover:underline">
              {t('payment.cancel.contactUs', 'Contact us')}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
